__turbopack_context__.v({
  "className": "instrument_sans_4c47f74c-module__s0Jimq__className",
  "variable": "instrument_sans_4c47f74c-module__s0Jimq__variable",
});
